import { Box, Modal, Typography, useTheme } from "@mui/material";
import ButtonCst from "@components/ButtonCst";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActionsContainer,
  Header,
  RootContainer,
} from "@pages/Contents/Skills/JobsCatalog/Jobs/KnowledgeDomainsAssociation/components/DomainLevelAssociationModal/style";
import SelectCst from "@components/InputCst/SelectCst";
import { Level } from "@pages/Contents/Skills/Levels/types";

interface DomainLevelAssociationModalProps {
  levels: Level[];
  selectedDomain: any;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedLevel: Level) => void;
}

const DomainLevelAssociationModal = ({
  levels,
  selectedDomain,
  isOpen,
  onClose,
  onConfirm,
}: DomainLevelAssociationModalProps) => {
  const { t } = useTranslation(["skills-knowledgeDomains-page"]);
  const theme = useTheme();
  const [selectedLevel, setSelectedLevel] = useState<Level | undefined>(
    undefined,
  );
  const [errors, setErrors] = useState<string[]>([]);

  const handleConfirm = () => {
    if (!selectedLevel) return setErrors([`${selectedDomain?.id}_level`]);
    onConfirm(selectedLevel);
    onClose();
  };

  const handleLevelSelection = (levelId: number) => {
    const level = levels.find((level) => level.id === levelId);
    setSelectedLevel(level);
  };

  useEffect(() => {
    setErrors([]);
    setSelectedLevel(undefined);
  }, [isOpen]);

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="modal-title">
      <RootContainer theme={theme}>
        <Header>
          <Typography
            id="modal-title"
            variant="h3"
            component="h2"
            sx={{ paddingBottom: "10px" }}
          >
            {t("level-association-modal.title")}
          </Typography>
          <Typography
            sx={{ fontsize: 16 }}
            dangerouslySetInnerHTML={{
              __html: t("level-association-modal.description", {
                domainName: selectedDomain?.name,
              }),
            }}
          />
        </Header>
        <Box
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <SelectCst
            id={"domain_level_association"}
            required
            error={errors.includes(`${selectedDomain?.id}_level`)}
            placeholder={
              t("level-association-modal.level-select-label") ??
              "Livello da associare"
            }
            label={
              t("level-association-modal.level-select-ph") ??
              "Livello da associare"
            }
            size={"small"}
            variant={"outlined"}
            options={levels.map((level) => ({
              label: level.name,
              value: level.id ?? level.name,
            }))}
            onChange={(value) => handleLevelSelection(value)}
            value={selectedLevel?.id}
          />
        </Box>
        <ActionsContainer theme={theme}>
          <ButtonCst id="cancel" color="primary" onClick={onClose}>
            {t("level-association-modal.cancel-cta")}
          </ButtonCst>
          <ButtonCst
            id={"confirmBtn"}
            variant="contained"
            color="primary"
            onClick={handleConfirm}
          >
            {t("level-association-modal.confirm-cta")}
          </ButtonCst>
        </ActionsContainer>
      </RootContainer>
    </Modal>
  );
};

export default DomainLevelAssociationModal;
